@for (status of statuses(); track status.id; let index = $index) {
  <div
    class="status"
    [style.gridArea]="`status${index + 1}`"
  >
    <div class="header">
      <div
        class="label"
        [matTooltip]="status.tooltip"
      >
        <div [class]="`icon-${index + 1} icon`"></div>
        {{ status.name }}
      </div>
      @if (!showMode()) {
        <button
          procure-button
          color="primary"
          condensedIcon="add"
          [matTooltip]="`Add supplier to type ${status.name}`"
          (click)="onAdd(status)"
        ></button>
      }
    </div>
    <div class="items">
      @for (item of items() | classification: status.id; track item.id) {
        <div class="item">
          <ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: item }" />
          @if (!showMode()) {
            <button
              procure-button
              color="white"
              condensedIcon="delete"
              elevated
              (click)="remove.emit(item.id)"
            ></button>
          }
        </div>
      }
    </div>
  </div>
}
